import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { OrderType } from '../../../interfaces/delivery-company/orders';
import { IFieldConfig, IFooterRow } from './report';
import { ReportTableFooter } from './table-footer';
import { ReportTableHeader } from './table-header';
import { ReportTableRows } from './table-rows';
import { useContext } from 'react';
import { OrgSettingsContext } from '../../../contexts/org-settings-context';
import { IOrderDeliveryTask, IPickupTask } from '../../../interfaces/delivery-company/tasks';

interface TableSeparatorProps {
  title: string;
  color: string;
}

const TableSeparator = ({ title, color }: TableSeparatorProps) => {
  return (
    <View
      style={{
        letterSpacing: 1,
        fontSize: 12,
        textAlign: 'center',
        textTransform: 'uppercase',
        backgroundColor: color,
        width: '100%',
        padding: 3,
      }}
    >
      <Text
        style={{
          textAlign: 'center',
        }}
      >
        {title}
      </Text>
    </View>
  );
};

interface ReportTableProps<T extends OrderType | IPickupTask | IOrderDeliveryTask> {
  items: T[];
  fields_config: IFieldConfig<T>[];
  title: string;
  on_new_page: boolean;
  header_bg: string;
  table_footer_rows: IFooterRow<T>[];
  color: string;
  index: number;
}

export function ReportTable<T extends OrderType | IPickupTask | IOrderDeliveryTask>({
  items,
  fields_config,
  title,
  header_bg,
  color,
  table_footer_rows,
  index,
}: ReportTableProps<T>) {
  const styles = (color: string) =>
    StyleSheet.create({
      tableContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 24,
        borderWidth: 1,
        borderColor: color,
        width: '100%',
      },
    });
  {
    return < View style={styles(color).tableContainer} break={index > 0} >
      <TableSeparator title={title} color={header_bg} />
      <ReportTableHeader fields_config={fields_config} color={color} />
      <ReportTableRows<T>
        items={items}
        fields_config={fields_config}
        color={color}
      />
      <ReportTableFooter<T>
        items={items}
        color={color}
        table_footer_rows={table_footer_rows}
      />
    </View >

  }

}